<template>
  <section>
    <el-container style="overflow:hidden;">
      <div style="float: left; width: 70%;">
        <el-form inline>
          <el-form-item label="收货单号">
            <el-input
              v-model="filters.keyword"
              id="inputId"
              placeholder="请输入收货单号"
              clearable
              @keypress.native.enter="getTWDeliveryInfo"
              @input="inputChange($event, 'keyword')"
            ></el-input>
          </el-form-item>
          <el-form-item label="扫码箱唛">
            <el-input
              id="inputName"
              v-model="filters.boxMark"
              placeholder="请输入扫码箱唛"
              clearable
              @keypress.native.enter="getSingleBoxMark"
                @input="inputChange($event, 'boxMark')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="float: left; width: 30%">
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>

        <!-- <el-button type="primary" @click="addBoxMark">提交</el-button> -->
      </div>
    </el-container>
    <el-container>
      <el-main>
        <div style="float: left; width: 25%">
          <el-card class="box-card" style="background-color: #f0f0f0">
            <div class="text item">
              <p>收货单号：{{ Deliverydata.twDeliveryNo }}</p>
              <p>仓库：{{ Deliverydata.warehouseCode }}</p>
              <p>收货状态：{{ Deliverydata.statusshow }}</p>
              <p>总重量(KG):{{ Deliverydata.totalGrossWeight }}</p>
              <p>总体积(方):{{ Deliverydata.totalVolume }}</p>
              <p>总箱数:{{ Deliverydata.totalBoxCount }}</p>
              <p>已收箱数:{{ Deliverydata.completeBoxCount }}</p>
              <p>参考号:{{ Deliverydata.relationNumber }}</p>
              <p>跟踪单号:{{ Deliverydata.trackNumber }}</p>
            </div>
          </el-card>
        </div>
        <div style="float: left; margin-left: 2%; width: 72%" class="otherTable">
          <p>收货明细：</p>
          <el-table-bar :fixed="true" :bottom="35">
            <el-table
              border
              :data="tableData"
              style="width: 100%"
              v-loading="listLoading"
            >
              <el-table-column prop="boxMark" label="箱唛" sortable>
              </el-table-column>
              <el-table-column label="尺寸(cm)">
                <template slot-scope="scope">{{
                  scope.row.boxLength +
                  "*" +
                  scope.row.boxWidth +
                  "*" +
                  scope.row.boxHeight
                }}</template>
              </el-table-column>
              <el-table-column prop="volume" label="体积(m³)" sortable>
              </el-table-column>

              <el-table-column prop="boxWeight" label="重量(Kg)" sortable>
              </el-table-column>
              <el-table-column prop="customName" label="客户" sortable>
              </el-table-column>
               <el-table-column
                prop="sku"
                label="产品信息"        
                min-width="130"
              >
                  <template slot-scope="scope">
                <div
                  v-if="
                    scope.row.sku != null && scope.row.sku != ''"
                >
                  <div
                    v-for="(item, index) in scope.row.sku.split(',')"
                    :key="index"
                  >
                    {{item}}
                  </div>
                </div>
                  </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    @click="delboxMark(scope.row.boxMark)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-table-bar>
          <div class="block">
            <el-pagination layout="total" :total="total" style="float: right">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </section>
</template>

<script>
import {
  getBatchGoodAsync,
  getBatchGoodDetailAsync,
  insertAccordingSignFor,
} from "@/api/receive/BatchGoods.js";
import { getButtonList } from "../../promissionRouter";

import Toolbar from "../../components/Toolbar";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      listLoading: false,
      tableData: [],
      Deliverydata: [],
      total: 0,
      validation: true,
    };
  },
  methods: {
    callFunction(item) {
      // this.filters = {
      //     keyword: item.search
      // };
      this[item.func].apply(this, item);
    },

    // input 搜索框值改变事件
    inputChange(val, item) {
      console.log(val);
      const s = [",", ";", "'"];
      let m = s.filter((res) => {
        return val === res;
      });
      if (m.length || val.includes("'")) {
        val = "";
      }
      let v = val.trim().replace(" ", ",");
      this.$set(this.filters, item, v);
    },
    //查询收货信息
    getTWDeliveryInfo() {
      if (this.filters.keyword == "" || this.filters.keyword == null) {
        this.$message({
          message: "请输入收货单号",
          type: "error",
        });
        this.Deliverydata = [];
        this.tableData = [];
        return;
      }

      let para = { key: this.filters.keyword };
      getBatchGoodAsync(para).then((res) => {
        this.tableData = [];
        if (res.data.success) {
          this.Deliverydata = res.data.response;
          console.log(this.Deliverydata);
          document.getElementById("inputName").focus();
        } else {
          this.Deliverydata = [];
          this.$message({
            message: res.data.msg,
            type: "error",
          });

          this.$set(this.filters, "keyword", "");
        }
      });
    },
    //删除箱唛
    delboxMark(boxMark) {
      this.$confirm("确认删除箱唛吗?", "提示", {}).then(() => {
        const index = this.tableData.findIndex(
          (item) => item.boxMark === boxMark
        );
        if (index > -1) {
          this.tableData.splice(index, 1);
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.total = this.tableData.length;
        } else {
          this.$message({
            message: "删除失败",
            type: "error",
          });
        }
      });
    },
    //查询单个箱唛
    getSingleBoxMark() {
      if (this.filters.boxMark == "" || this.filters.boxMark == undefined) {
        this.$message({
          message: "请输入箱唛",
          type: "error",
        });
        return;
      }
      const index = this.tableData.findIndex(
        (item) => item.boxMark === this.filters.boxMark
      );
      if (index > -1) {
        this.$message({
          message: "箱唛已扫码",
          type: "error",
        });
      } else {
        this.getBoxMark(1);
      }
    },

    //查询多个
    getListBoxMark() {
      this.getBoxMark(2);
    },
    //查询箱唛信息
    getBoxMark(type) {
      if (
        this.Deliverydata.twDeliveryNo == "" ||
        this.Deliverydata.length == 0
      ) {
        this.$message({
          message: "请先查询收货单信息",
          type: "error",
        });
        return;
      }
      let para = {
        key: this.Deliverydata.twDeliveryNo,
        boxMark: this.filters.boxMark,
        type: type,
      };
      getBatchGoodDetailAsync(para).then((res) => {
        if (res.data.success) {
          if (type == 1) {
            res.data.response.forEach((element) => {
              this.tableData.push(JSON.parse(JSON.stringify(element)));
            });
            this.$message({
              message: "扫码成功",
              type: "success",
            });
          } else {
            this.tableData = res.data.response;
            this.$message({
              message: "查询成功",
              type: "success",
            });
          }
          this.total = this.tableData.length;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        console.log(this.tableData);
        this.$set(this.filters, "boxMark", "");
        //this.filters.boxMark = "";
      });
    },
    //保存箱唛信息
    addBoxMark() {
      this.validation = true;
      if (
        this.Deliverydata.twDeliveryNo == "" ||
        this.Deliverydata.length == 0
      ) {
        this.validation = false;
        this.$message({
          message: "请先查询收货单信息",
          type: "error",
        });
        return;
      }

      if (this.tableData.length == 0) {
        this.validation = false;
        this.$message({
          message: "请扫描箱唛",
          type: "error",
        });
        return;
      }
      let pata = {
        twdeliveryNo: this.Deliverydata.twDeliveryNo,
      };
      pata.data = Object.assign([], this.tableData);
      console.log(pata);

      if (this.validation) {
        this.$confirm("确认提交吗?", "提示", {})
          .then(() => {
            insertAccordingSignFor(pata).then((res) => {
              if (res.data.success) {
                this.Deliverydata = [];
                this.tableData = [];
                this.$set(this.filters, "keyword", "");
                document.getElementById("inputId").focus();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getWarelist();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },

  mounted() {
    document.getElementById("inputId").focus();
    let user = JSON.parse(window.localStorage.user);
    console.info(user);
    this.typeVisible = user.isSa;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style>
</style>